
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 22l.014.048h.003l.01-.003.036-.01.132-.038.405-.113.645-.182c3.03-.855 5.472-3.038 6.74-5.979h0l.001-.004.018-.05a.619.619 0 00.046-.218V5.63h0v-.005c-.033-.368-.328-.675-.696-.675a9.916 9.916 0 01-6.919-2.82h0-.002c-.263-.237-.663-.24-.899.001a9.916 9.916 0 01-6.919 2.819.674.674 0 00-.665.68v9.822c0 .085.023.149.046.217l.018.05h0l.002.005c1.267 2.941 3.71 5.124 6.74 5.979l.64.18.407.115.133.037.037.01.01.003.003.001h0L12 22zm0 0l.014.048-.014.004-.013-.004L12 22zm-1.868-7.556l.299-.306.764.782.036.037.036-.037.861-.882.034-.035-.034-.035-.766-.783 1.11-1.136c.305.151.64.241 1.005.241 1.229 0 2.204-1 2.204-2.254s-.975-2.254-2.204-2.254c-1.228 0-2.204 1-2.204 2.254h0v.004c.03.371.12.713.267 1.026l-3.237 3.343-.034.035.034.035 1.661 1.7.036.037.036-.037.861-.882.035-.035-.035-.035-.765-.783zm8.557.871a9.08 9.08 0 01-5.81 5.094s0 0 0 0l-.91.248-.909-.248s0 0 0 0a9.08 9.08 0 01-5.81-5.094v-9.04c2.472-.136 4.821-1.105 6.72-2.753 1.897 1.648 4.247 2.617 6.719 2.752v9.041zm-5.181-6.173c.494 0 .873.386.873.894 0 .509-.379.895-.873.895s-.873-.386-.873-.895c0-.508.379-.894.873-.894z","fill":"#9AA0B5","stroke":"#9AA0B5","stroke-width":".1"}})])
          )
        }
      }
    